import { jsxs, jsx } from "react/jsx-runtime";
import { hues, white } from "@sanity/color";
import { forwardRef } from "react";
const GroqLogo = /* @__PURE__ */ forwardRef(function(props, ref) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      "data-sanity-icon": "groq-logo",
      height: "1em",
      viewBox: "0 0 304 64",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      ref,
      children: [
        /* @__PURE__ */ jsx("path", { d: "M32 0L0 32H32V0Z", fill: hues.magenta[400].hex }),
        /* @__PURE__ */ jsx("path", { d: "M32 32H0L32 64V32Z", fill: hues.green[300].hex }),
        /* @__PURE__ */ jsx("path", { d: "M64 32H32V64L64 32Z", fill: hues.purple[300].hex }),
        /* @__PURE__ */ jsx("path", { d: "M112 0L80 32H112V0Z", fill: hues.green[300].hex }),
        /* @__PURE__ */ jsx("path", { d: "M112 0H80V32L112 0Z", fill: hues.purple[300].hex }),
        /* @__PURE__ */ jsx("path", { d: "M112 32H80L112 64V32Z", fill: hues.yellow[200].hex }),
        /* @__PURE__ */ jsx("path", { d: "M144 64L112 32V64H144Z", fill: hues.blue[300].hex }),
        /* @__PURE__ */ jsx("path", { d: "M80 32V64H112L80 32Z", fill: hues.orange[400].hex }),
        /* @__PURE__ */ jsx("path", { d: "M112 0V32H144L112 0Z", fill: hues.magenta[400].hex }),
        /* @__PURE__ */ jsx("path", { d: "M192 0L160 32H192V0Z", fill: hues.yellow[200].hex }),
        /* @__PURE__ */ jsx("path", { d: "M192 32H160L192 64V32Z", fill: hues.orange[400].hex }),
        /* @__PURE__ */ jsx("path", { d: "M224 32H192V64L224 32Z", fill: hues.green[300].hex }),
        /* @__PURE__ */ jsx("path", { d: "M192 0V32H224L192 0Z", fill: hues.blue[300].hex }),
        /* @__PURE__ */ jsx("path", { d: "M272 0L240 32H272V0Z", fill: hues.purple[300].hex }),
        /* @__PURE__ */ jsx("path", { d: "M304 32L272 64H304V32Z", fill: hues.magenta[400].hex }),
        /* @__PURE__ */ jsx("path", { d: "M272 32H240L272 64V32Z", fill: hues.blue[300].hex }),
        /* @__PURE__ */ jsx("path", { d: "M304 32H272V64L304 32Z", fill: hues.yellow[200].hex }),
        /* @__PURE__ */ jsx("path", { d: "M272 0V32H304L272 0Z", fill: hues.green[300].hex })
      ]
    }
  );
}), GroqMonogram = /* @__PURE__ */ forwardRef(function(props, ref) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      "data-sanity-icon": "groq-monogram",
      width: "1em",
      height: "1em",
      viewBox: "0 0 128 128",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      ref,
      children: [
        /* @__PURE__ */ jsx("rect", { width: "128", height: "128", rx: "8", fill: hues.green[950].hex }),
        /* @__PURE__ */ jsx("rect", { y: "32", width: "64", height: "64", fill: hues.green[800].hex }),
        /* @__PURE__ */ jsx("path", { d: "M64 32L32 64H64V32Z", fill: hues.magenta[400].hex }),
        /* @__PURE__ */ jsx("path", { d: "M64 64H32L64 96V64Z", fill: hues.green[300].hex }),
        /* @__PURE__ */ jsx("path", { d: "M96 64H64V96L96 64Z", fill: hues.purple[300].hex })
      ]
    }
  );
}), NEW_SANITY_ORANGE = "#FF5500", NEW_SANITY_BLACK = "#0D0E12", SanityLogo = /* @__PURE__ */ forwardRef(function(props, ref) {
  const { dark, ...svgProps } = props, fill = dark ? white.hex : NEW_SANITY_BLACK;
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      "data-sanity-icon": "sanity-logo",
      height: "1em",
      viewBox: "0 0 435 154",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...svgProps,
      ref,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M44.883 52.4463C33.4181 43.7972 21.8121 37.1021 21.8121 27.3381C21.8121 21.482 26.9827 15.4851 34.1181 15.4851C46.983 15.4851 54.5302 28.8754 61.942 45.6103H66.5538V7.11182H34.3946C7.82952 7.11182 0 23.1543 0 35.7055C0 52.1647 13.5649 61.9287 28.9416 73.365C39.7064 81.3158 48.7948 88.7092 48.7948 97.2175C48.7948 106.424 42.5006 111.723 34.5299 111.723C26.0004 111.723 13.4178 100.562 4.60595 77.4137H0V120.096H36.777C59.4302 120.096 70.7539 102.24 71.1716 87.876C71.7304 71.1411 57.3302 61.7937 44.883 52.4463Z",
            fill
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M145.002 106.841V61.7878C145.002 42.2598 132.837 37.1021 115.219 37.1021H83.8952L84.0364 68.9054H89.2071C94.6601 55.3743 102.49 45.4754 110.878 45.4754C118.149 45.4754 121.366 51.7539 121.366 58.3082V64.4459C109.619 71.4227 78.301 77.2788 78.301 98.4791C78.301 110.754 86.8306 120.935 99.2778 120.935C110.043 120.935 117.454 113.958 121.231 105.732C121.931 112.568 126.402 120.096 136.614 120.096H152.696V113.958C147.525 113.958 145.008 110.473 145.008 106.847L145.002 106.841ZM120.949 99.8639C118.713 103.074 115.213 106.7 111.019 106.7C105.148 106.7 101.372 102.234 101.372 93.3096C101.372 83.129 115.072 76.5746 120.949 71.6926V99.8697V99.8639Z",
            fill
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M270.145 28.4529C279.092 28.4529 284.686 22.1744 284.686 14.0885C284.686 6.00274 279.092 0 270.145 0C261.198 0 255.462 5.99688 255.462 14.0885C255.462 22.1802 261.474 28.4529 270.145 28.4529Z",
            fill
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M409.135 37.102V43.2397C417.947 43.2397 420.459 47.84 416.129 60.2563L405.641 88.5683L392.217 54.1186C389.141 47.4234 390.817 43.2397 397.252 43.2397V37.102H330.557V9.20654H324.263C322.446 18.6889 312.516 37.102 295.598 37.102V43.2397H306.504V100.568C306.504 110.191 309.722 121.07 328.457 121.07H357.54V89.5482H352.37C350.269 96.9417 345.94 111.723 336.569 111.723C331.399 111.723 330.557 106.002 330.557 101.401V45.8861H357.264C360.481 45.8861 363.834 46.3027 365.511 50.2106L393.894 120.231C388.441 132.647 379.07 134.595 362.293 129.437V153.988C366.629 153.988 377.811 154.129 379.77 153.572C390.817 150.362 398.364 128.745 401.441 120.378L425.488 55.521C428.147 48.4092 430.382 43.2456 434.994 43.2456V37.1079H409.129L409.135 37.102Z",
            fill
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M237.703 106.841V59.2764C237.703 44.3546 230.574 35.4238 216.45 35.4238C204.009 35.4238 196.803 44.0319 191.279 52.0414V37.0961H159.396V43.2338C164.849 43.2338 167.226 46.5785 167.226 50.4864V106.835C167.226 110.602 164.432 113.947 159.396 113.947V120.084H199.109V113.947C194.073 113.947 191.279 110.602 191.279 106.835V59.646C194.503 55.3743 198.214 50.7681 204.42 50.7681C210.291 50.7681 213.65 55.5093 213.65 61.2303V106.841C213.65 110.608 210.856 113.952 205.82 113.952V120.09H245.533V113.952C240.497 113.952 237.703 110.608 237.703 106.841Z",
            fill
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M284.127 106.841V37.1021H252.245V43.2398C257.698 43.2398 260.074 46.5844 260.074 50.4923V106.841C260.074 110.608 257.28 113.952 252.245 113.952V120.09H291.957V113.952C286.922 113.952 284.127 110.608 284.127 106.841Z",
            fill
          }
        )
      ]
    }
  );
}), SANITY_MONOGRAM_COLOR = {
  light: { bg: white.hex, fg: NEW_SANITY_BLACK },
  dark: { bg: NEW_SANITY_BLACK, fg: white.hex },
  default: { bg: NEW_SANITY_ORANGE, fg: NEW_SANITY_BLACK }
}, SanityMonogram = /* @__PURE__ */ forwardRef(function(props, ref) {
  const { scheme = "default", color, ...restProps } = props, bg = color?.bg1 || SANITY_MONOGRAM_COLOR[scheme].bg, fg = color?.fg || SANITY_MONOGRAM_COLOR[scheme].fg;
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      "data-sanity-icon": "sanity-monogram",
      height: "1em",
      viewBox: "0 0 192 192",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...restProps,
      ref,
      children: [
        /* @__PURE__ */ jsx("rect", { width: "192", height: "192", fill: bg }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M160.077 112.697L154.865 103.629L129.659 118.981L157.655 83.3368L161.888 80.8533L160.841 79.2802L162.764 76.8232L153.929 69.4699L149.886 74.6225L68.2657 122.375L98.4429 86.0855L154.651 55.2759L149.311 44.953L118.696 61.7277L133.771 43.6096L125.134 36L91.2055 76.7966L57.5083 95.2771L83.307 61.1709L99.4731 52.757L94.3391 42.3192L47.2403 66.8361L60.0839 49.8405L51.1123 42.6551L24 78.5378L24.4207 78.8736L29.486 89.1877L59.543 73.5354L32.1474 109.745L36.6375 113.342L39.3075 118.504L70.9528 101.154L36.1052 143.065L44.742 150.674L46.4762 148.588L130.543 99.2454L102.632 134.792L103.088 135.172L103.045 135.199L108.831 145.265L145.954 122.649L131.659 145.716L141.24 152L164 115.278L160.077 112.697Z",
            fill: fg
          }
        )
      ]
    }
  );
});
export {
  GroqLogo,
  GroqMonogram,
  SanityLogo,
  SanityMonogram
};
//# sourceMappingURL=index.js.map
